// extracted by mini-css-extract-plugin
export default {"list":"ServicesList_list__5srmP"};